import { StaticJsonRpcProvider } from '@ethersproject/providers'

export const BSC_PROD_NODE = process.env.NEXT_PUBLIC_NODE_PRODUCTION || 'https://cloudflare-eth.com'

//todo:peta 默认的provider 会调blocknumber 之类的
export const bscRpcProvider = new StaticJsonRpcProvider(BSC_PROD_NODE)

export default null
